import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';
import FontKeys from '../FontKeys';
import gameData, { GameVersions, GAME_IMAGES_KEY } from '../gameData';

export default class PatternCardItem extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, val) {
    super(scene);

    this.val = val;

    this.cardBg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._card_bg, this).setOrigin(0);

    if (gameData.gameVersion === GameVersions.Number) {
      this.valTxt = ABCyaPhaser.Text.addText(this.cardBg.width / 2, this.cardBg.height / 2, '36pt', 0xA2A4A7, FontKeys.bpreplaybold, this.val.toString(),this, true).setOrigin(0.5);
    }
    else {
      this.valDisplay = ABCyaPhaser.Images.addImage(this.cardBg.width / 2,this.cardBg.height / 2, `pattern-${this.val}`, this, GAME_IMAGES_KEY).setOrigin(0.5);
    }
  }

  removeIt () {
    const dir = Phaser.Math.Between(0,1) === 0 ? -100 : 100;
    const r = Phaser.Math.Between(0,1) === 0 ? -360 : 360;
    ABCyaPhaser.Tweens.addTween(this, 500, { angle: r, x: this.x + dir, y: this.y + 400, alpha: 0, scale: 0.5 }, Phaser.Math.Easing.Quadratic.In, () => this.destroy());
  }
}